'use strict';exports.__esModule = true;exports.constructCompanyLink = undefined;var _appendLocale = require('./appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// eslint-disable-next-line import/prefer-default-export
var constructCompanyLink = exports.constructCompanyLink = function constructCompanyLink(locale, companyId) {return (0, _appendLocale2.default)(locale, '/company/' + companyId);};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/constructLink.js
// module id = 389
// module chunks = 0